import { render, staticRenderFns } from "./EndpointsGrid.vue?vue&type=template&id=255355ec"
import script from "./EndpointsGrid.vue?vue&type=script&lang=js"
export * from "./EndpointsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255355ec')) {
      api.createRecord('255355ec', component.options)
    } else {
      api.reload('255355ec', component.options)
    }
    module.hot.accept("./EndpointsGrid.vue?vue&type=template&id=255355ec", function () {
      api.rerender('255355ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/EndpointsGrid.vue"
export default component.exports